{
  "LOGIN": {
    "TITLE": "Melden Sie sich bei Chatwoot an",
    "EMAIL": {
      "LABEL": "E-Mail",
      "PLACEHOLDER": "example{'@'}companyname.com",
      "ERROR": "Bitte geben Sie eine gültige E-Mail-Adresse ein"
    },
    "PASSWORD": {
      "LABEL": "Passwort",
      "PLACEHOLDER": "Passwort"
    },
    "API": {
      "SUCCESS_MESSAGE": "Anmeldung erfolgreich",
      "ERROR_MESSAGE": "Es konnte keine Verbindung zum Woot Server hergestellt werden. Bitte versuchen Sie es später erneut",
      "UNAUTH": "Benutzername / Passwort falsch. Bitte versuche es erneut"
    },
    "OAUTH": {
      "GOOGLE_LOGIN": "Mit Google anmelden",
      "BUSINESS_ACCOUNTS_ONLY": "Bitte verwenden Sie Ihre Firmen-E-Mail-Adresse zum Anmelden",
      "NO_ACCOUNT_FOUND": "Wir konnten kein Konto für Ihre E-Mail-Adresse finden."
    },
    "FORGOT_PASSWORD": "Haben Sie Ihr Passwort vergessen?",
    "CREATE_NEW_ACCOUNT": "Neuen Account erstellen",
    "SUBMIT": "Einloggen",
    "SAML": {
      "LABEL": "Login via SSO",
      "TITLE": "Initiate Single Sign-on (SSO)",
      "SUBTITLE": "Enter your work email to access your organization",
      "BACK_TO_LOGIN": "Login via Password",
      "WORK_EMAIL": {
        "LABEL": "Work Email",
        "PLACEHOLDER": "Enter your work email"
      },
      "SUBMIT": "Continue with SSO",
      "API": {
        "ERROR_MESSAGE": "SSO authentication failed. Please check your credentials and try again."
      }
    }
  }
}
